import { Component, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { Employee } from '@app/models/employee/employee.model';
import { VacationYtdAdjusmentsHistoryTable } from '@app/modules/payroll/services/tables/vacation-ytd-adjustments-history-table/vacation-ytd-adjustments-history.table';
import { AuthService, NotifyService, PayrollService } from '@app/services';
import { PayrollSettingsService } from '@app/services/payroll-settings.service';

@Component({
    templateUrl: './vacation-ytd-adjustment-history.template.html',
})
export class VacationYtdAdjustmentHistoryView implements OnInit {
    isLoading = true;
    employee: Employee;
    displayVacationYtdAdjustmentHistoryTable = false;
    vacationYtdAdjusmentsHistoryTable: VacationYtdAdjusmentsHistoryTable;
    pendingPayrollExists = false;
    displayMakeAdjustmentButton = false;

    constructor(
        private auth: AuthService,
        private route: ActivatedRoute,
        private payrollService: PayrollService,
        private settingsService: PayrollSettingsService,
        private notify: NotifyService
    ) {
        this.route.params.pipe(takeUntilDestroyed()).subscribe(async (params) => {
            const employeeId = params['employee'];
            this.employee = await Employee.param('company', this.auth.company.id).find(employeeId);
            this.vacationYtdAdjusmentsHistoryTable = new VacationYtdAdjusmentsHistoryTable(employeeId);
            this.displayVacationYtdAdjustmentHistoryTable = true;
            this.isLoading = false;
        });
    }

    async ngOnInit(): Promise<void> {
        try {
            await this.settingsService.load();
            const pendingPayrollStatus = await this.payrollService.getPendingPayrollStatus();
            this.pendingPayrollExists = pendingPayrollStatus.exists;
            if (!this.pendingPayrollExists) {
                this.displayMakeAdjustmentButton = true;
            }
        } catch (error) {
            this.notify.error(error);
            this.isLoading = false;
        }
    }
}
